exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form .bank-details[data-v-c95a5760]{font-size:small;border-bottom:1px solid #aaa;padding-bottom:10px;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.oi-donation-form .bank-details .details[data-v-c95a5760],.oi-donation-form .terms[data-v-c95a5760]{margin-bottom:20px}", ""]);

// exports
